export default __webpack_public_path__ + "static/media/heartIcon_inactive.5590264f.svg";